import { ActionTree } from 'vuex';
import {
  LIST_MASTER_ACCOUNTS,
  SET_MASTER_ACCOUNT,
  SET_CURRENT_USER_DATA,
  SET_ERROR,
  UPDATE_USER_LOCALE,
  UserState
} from './types';
import { userAuthServiceApi } from './callers';

const actions: ActionTree<UserState, Record<string, never>> = {
  async [LIST_MASTER_ACCOUNTS]({ commit }) {
    return userAuthServiceApi.listMasterAccounts()
      .then((res) => {
        commit(LIST_MASTER_ACCOUNTS, res);
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
      });
  },
  [SET_MASTER_ACCOUNT]({ commit }, payload): void {
    commit(SET_MASTER_ACCOUNT, payload);
  },
  async [SET_CURRENT_USER_DATA]({ commit, dispatch }, payload): Promise<void> {
    commit(SET_CURRENT_USER_DATA, payload);
    await dispatch('permissions/fetchCurrentUserRolePermissions', payload, {
      root: true
    });
  },
  async [UPDATE_USER_LOCALE]({ commit }, payload: { locale?: string }): Promise<Response> {
    commit(UPDATE_USER_LOCALE, payload);
    return userAuthServiceApi.updateUserAttribute(payload);
  }
};

export default actions;
